<template>
	<view style="overflow: hidden;"
		:style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">
		<view style="padding: 10px; border-radius: 10px; overflow: hidden;">
			<!-- <uni-section title="数字人" type="line" > -->

			<view style="height: 20px; color: white; margin-bottom: 10px; margin-top: 20px;">数字人</view>
			<view style="display: flex;  flex-wrap: wrap;  overflow-x: auto; background: transparent;">
				<view @click="createAvatar"
					style="margin-right: 10px; flex: 0 0 auto; margin-bottom: 10px; width: 30%; min-height: 180px;  max-height: 180px;  text-align: center; background: #13242e; border-radius: 5px; color: darkgray; ">
					<view style="height: 50px;"></view>
					<uni-icons style="" color="darkgrey" style="" type="plusempty" size="30"></uni-icons>
					<view>定制数字人</view>
				</view>

				<view @click="clickAvatar" 
					style="margin-right: 10px; flex: 0 0 auto; margin-bottom: 10px; width:30%; min-height: 180px;  max-height: 180px; line-height: 150px; text-align: center; background: #F6F6F6; border-radius: 5px; overflow: hidden;"
					v-for="item in avatars">
					<text v-if="!item.cover">{{item.title}}</text>
					<image v-if="item.cover" :src="item.cover" style="width: 100%; " mode="widthFix">
					</image>
				</view>

			</view>

			<!-- </uni-section> -->

			<view
				style="display: flex; height: 20px; color: white; margin-bottom: 10px; margin-top: 40px; margin-bottom: 10px;">
				<text>作品</text>
				<view style="margin-left: 10px;" @click="getVideoList"><uni-icons color="white" type="refreshempty"
						size="20"></uni-icons></view>
			</view>
			<!-- <uni-section title="作品" type="line"> -->

			<view style="display: flex; flex-wrap: wrap;">

				<view @click="clickAvatar"
					style="margin-right: 10px; flex: 0 0 auto; width: 30%; min-height: 180px;  max-height: 180px;  text-align: center; background: #13242e; border-radius: 5px; color: darkgray; ">
					<view style="height: 50px;"></view>
					<uni-icons style="" color="darkgrey" style="" type="plusempty" size="30"></uni-icons>
					<view>创建作品</view>
				</view>
				<view @click="clickVideo(item)"
					style="margin-right: 10px; flex: 0 0 auto; margin-bottom: 20px; width: 30%; min-height: 180px;  max-height: 180px; line-height: 150px; text-align: center; background: #F6F6F6; border-radius: 5px; overflow: hidden;"
					v-for="item in videos">
					<div class="image-container">
						<image :src="item.cover" style="width: 100%; height: 100%;"></image>
						<div v-if="!item.url" class="overlay"><text style="margin-left: 5px;" v-if="item.progress">{{item.progress}}</text></div>
					</div>
				</view>

			</view>

			<!-- </uni-section> -->

		</view>
	</view>
</template>

<script>
	export default {
		name: 'Tpl_Avatar',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
		},
		data() {
			return {
				avatars: [],
				videos: [],
			}
		},
		mounted() {
			this.refresh()
		},


		methods: {
			refresh() {
				if (uni.getStorageSync('token')) {
					this.getVideoAvatarList()
					this.getVideoList()
				}
			},
			createAvatar() {
				uni.navigateTo({
					url: '/pages/aigc/avatar_create'
				})
			},

			clickAvatar() {
				uni.navigateTo({
					url: '/pages/aigc/video_create'
				})
			},

			clickVideo(item) {
				console.log(item)
				if(!item.url){
					this.getVideoList()
					return
				}
				uni.navigateTo({
					url: '/pages/common/video_play?url=' + item.url
				})
			},

			getVideoAvatarList: function() {
				let t = this;
				this.$get({
					context: t,
					path: '/aigc/video/avatar/list/',
					params: {},
					success: function(data) {
						console.log(data)
						t.avatars = data.items;
					}
				})
			},
			getVideoList: function() {
				let t = this;
				this.$get({
					context: t,
					path: '/aigc/video/list/',
					params: {},
					success: function(data) {
						console.log(data)
						t.videos = data.videos;
					}
				})
			},

		}
	};
</script>

<style scoped>
	.image-container {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		/* 半透明背景 */
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
	}
</style>